(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-reviews-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.npr-root');
    if (!root || root.dataset.nprInit) return;
    root.dataset.nprInit = '1';

    var STORE = root.dataset.storeId;
    var PAGE_SIZE = parseInt(root.dataset.pageSize, 10) || 20;
    var PHOTOS_TOTAL = (root.dataset.photosCount || '').trim(); // e.g. "1,000+" — shown as the lightbox total
    var BASE = 'https://storefront-api.loox.io/storefront/v1/store/' + STORE + '/product-reviews';
    var GOLD = 'npr-star-on', OFF = 'npr-star-off';

    var grid = root.querySelector('#nprGrid');
    var moreBtn = root.querySelector('#nprMore');
    var loadingEl = root.querySelector('#nprLoading');
    var emptyEl = root.querySelector('#nprEmpty');
    var sortSel = root.querySelector('#nprSort');

    // sort 'photos' = "Newest (photos first)": ALL reviews, photo ones first (phase 1), then the rest (phase 2).
    // filterPhotos (the "With photos" chip) = hard filter to photo-only.
    var state = { sort: 'photos', rating: null, filterPhotos: false, size: null, frame: null, phase: 1, page: 1, hasMore: true, loading: false };

    /* ----- helpers ----- */
    function starSvgs(r) {
      // Same fractional ★ glyph as the collection tiles / PDP badge (np-stars) so the star shape is
      // identical across the whole site. Filled = solid gold, empty = hollow gold outline.
      var rHalf = Math.round((Number(r) || 0) * 2) / 2; // snap to nearest half star (Amazon-style)
      var pct = Math.max(0, Math.min(100, rHalf / 5 * 100));
      return '<span class="npr-fstars"><span class="npr-fstars-t">★★★★★</span><span class="npr-fstars-f" style="width:' + pct + '%">★★★★★</span></span>';
    }
    function starsHTML(r) { return '<span class="npr-stars">' + starSvgs(r) + '</span>'; }
    function initials(name) {
      if (!name) return '?';
      var p = name.replace(/[^A-Za-z .]/g, '').trim().split(/\s+/);
      return ((p[0] ? p[0][0] : '') + (p[1] ? p[1][0] : '')).toUpperCase() || '?';
    }
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function fmtDate(s) { // US format: "Jun 26, 2026"
      var d = new Date(s); if (isNaN(d)) return '';
      return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
    function esc(s) { var e = document.createElement('div'); e.textContent = s == null ? '' : s; return e.innerHTML; }
    var ITEMTYPES = window.__NP_LOOX_ITEMTYPES || {}; // { reviewId: "30 x 30 Inches / Oak Floating Frame" }
    function fmtVariant(v) { // "30 x 30 Inches / Oak Floating Frame" -> "30 × 30 in · Oak Floating Frame"
      return v.replace(/(\d)\s*x\s*(\d)/i, '$1 × $2').replace(/\s*Inches/i, ' in').replace(/\s*\/\s*/, ' · ');
    }

    /* ----- size / frame parsing for the filters (from the item-type map) ----- */
    // longest side → bucket. Catalog longest sides run ~20–58".
    var SIZE_BUCKETS = [
      { key: 'S', label: 'Small', max: 24 },
      { key: 'M', label: 'Medium', max: 32 },
      { key: 'L', label: 'Large', max: 40 },
      { key: 'XL', label: 'Extra Large', max: Infinity }
    ];
    function parseVariant(v) {
      var parts = (v || '').split('/');
      var nums = (parts[0] || '').match(/\d+(\.\d+)?/g);
      return { longest: nums ? Math.max.apply(null, nums.map(Number)) : 0, frame: (parts[1] || '').trim() };
    }
    function sizeBucketOf(v) {
      var n = parseVariant(v).longest; if (!n) return null;
      for (var i = 0; i < SIZE_BUCKETS.length; i++) if (n <= SIZE_BUCKETS[i].max) return SIZE_BUCKETS[i].key;
      return null;
    }
    function frameOf(v) { return parseVariant(v).frame; }
    function frameShort(f) { return f.replace(/Stretched Canvas Only/i, 'Canvas').replace(/\s*Floating Frame$/i, '').trim() || f; }

    // Build the Size + Frame chips from the FULL item-type map (real counts, no API needed).
    function buildFilters() {
      var sizeCounts = {}, frameCounts = {};
      Object.keys(ITEMTYPES).forEach(function (k) {
        var v = ITEMTYPES[k]; if (typeof v !== 'string') return;
        var b = sizeBucketOf(v); if (b) sizeCounts[b] = (sizeCounts[b] || 0) + 1;
        var f = frameOf(v); if (f) frameCounts[f] = (frameCounts[f] || 0) + 1;
      });
    }

    /* ----- summary (live aggregates) ----- */
    function buildSummary() {
      var calls = [1, 2, 3, 4, 5].map(function (r) {
        return fetch(BASE + '?rating=' + r + '&limit=1', { headers: {} })
          .then(function (res) { return res.json(); })
          .then(function (j) { return (j.pagination && j.pagination.total) || 0; })
          .catch(function () { return 0; });
      });
      Promise.all(calls).then(function (counts) {
        var total = counts.reduce(function (a, b) { return a + b; }, 0);
        if (!total) return;
        var sum = counts.reduce(function (a, c, i) { return a + c * (i + 1); }, 0);
        var avg = (sum / total);
        root.querySelector('#nprAvg').textContent = avg.toFixed(1);
        root.querySelector('#nprAvgStars').innerHTML = starSvgs(avg);
        root.querySelector('#nprTotal').textContent = (Math.floor(total / 10) * 10).toLocaleString() + '+';   // floored to 10 like np-reviews-total + the PDP widget (was exact + '+': '4,126+' beside the hero's '4,120+')
        root.querySelector('#nprPct').textContent = '91%'; // static brand-wide figure (NOT per-product)

        var bars = root.querySelector('#nprBars');
        var rows = '';
        for (var s = 5; s >= 1; s--) {
          var c = counts[s - 1];
          var pct = total ? (c / total * 100) : 0;
          rows += '<button type="button" class="npr-bar" data-rating="' + s + '">' +
            '<span class="npr-bar-lbl">' + s + ' star</span>' +
            '<span class="npr-bar-track"><span class="npr-bar-fill" style="width:' + pct.toFixed(1) + '%"></span></span>' +
            '<span class="npr-bar-ct">' + c.toLocaleString() + ' (<span class="npr-bar-pct">' + Math.round(pct) + '%</span>)</span>' +
            '</button>';
        }
        bars.insertAdjacentHTML('afterbegin', rows);
        applyBarActive();
      });
    }
    function applyBarActive() {
      root.querySelectorAll('.npr-bar').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.rating, 10) === state.rating);
      });
    }

    /* ----- trust + avg-stars icons ----- */
    var TRUST_ICONS = [
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="m21 16-5-5L5 20"/></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M21 8 12 3 3 8l9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8M12 13v8"/></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M1 4h13v12H1zM14 8h4l3 3v5h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 2 4 5v6c0 5 3.4 8.4 8 11 4.6-2.6 8-6 8-11V5Z"/><path d="m9 12 2 2 4-4"/></svg>'
    ];
    root.querySelectorAll('.npr-trust-ico').forEach(function (el) { el.innerHTML = TRUST_ICONS[el.dataset.ico] || ''; });

    /* ----- fetch + render reviews ----- */
    function queryURL() {
      var srt = state.sort === 'photos' ? 'date' : state.sort; // "Newest photos" = newest, photo-filtered
      var p = 'sort=' + srt + '&limit=' + PAGE_SIZE + '&page=' + state.page;
      if (state.rating) p += '&rating=' + state.rating;
      return BASE + '?' + p;
    }
    function passesClient(r) {
      var hasPhoto = !!(r.media && r.media.length);
      if (state.filterPhotos && !hasPhoto) return false;            // "With photos" chip = photo-only
      // size / frame filters (from the baked item-type map; reviews not in the map can't match a filter)
      if (state.size || state.frame) {
        var v = ITEMTYPES[r.id]; if (!v) return false;
        if (state.size && sizeBucketOf(v) !== state.size) return false;
        if (state.frame && frameOf(v) !== state.frame) return false;
      }
      if (state.sort === 'photos' && !state.filterPhotos) {         // "photos first" 2-phase ordering
        if (state.phase === 1 && !hasPhoto) return false;
        if (state.phase === 2 && hasPhoto) return false;            // phase 2 = the remaining (non-photo) reviews
      }
      return true;
    }

    var reviewStore = []; // full review objects, indexed for the lightbox
    var allPhotos = [];   // flat list of every loaded customer photo: {url, revIdx} — the lightbox browses this
    var VB_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2 4 5v6c0 5 3.4 8.4 8 11 4.6-2.6 8-6 8-11V5Z" opacity=".18"/><path fill="none" stroke="currentColor" stroke-width="1.6" d="M12 2 4 5v6c0 5 3.4 8.4 8 11 4.6-2.6 8-6 8-11V5Z"/><path fill="none" stroke="currentColor" stroke-width="1.7" d="m9 12 2 2 4-4"/></svg>';
    var CAM_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';

    function mediaOf(r) {
      return (r.media || []).filter(function (m) { return m.type === 'photo' && m.url; }).map(function (m) { return m.url; });
    }
    /* Small copies for thumbnails (2026-10-05). Loox only serves the ORIGINAL upload (0.5-1 MB each) and offers no
       thumbnail URL, so customer photos in the strip and on the cards go through a resizer (WebP, ~3-15 KB);
       Shopify product thumbs just get ?width=. The lightbox always opens the original (lbImg.src = p.url).
       If the resizer ever fails, onerror swaps the original back in. Swap IMG_PROXY for our own route later. */
    var IMG_PROXY = 'https://wsrv.nl/?url=';
    function small(url, w) {
      if (!url) return '';
      if (/^(https?:)?\/\/(cdn\.shopify\.com|[a-z0-9.-]*nordicpark\.co)\//i.test(url)) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      return IMG_PROXY + encodeURIComponent(url.replace(/^https?:\/\//, '')) + '&w=' + w + '&q=75&output=webp';
    }
    var FALLBACK = ' onerror="this.onerror=null;this.src=this.getAttribute(\'data-orig\')"';
    /* Watchdog (2026-10-06): the resizer can STALL on a cold photo (seen 21 s) without erroring, so onerror never
       fires and the card sits blank. Once a resized photo is on screen, give it 4 s, then load the original. */
    var SLOW_MS = 4000;
    var slowIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        var img = e.target; slowIO.unobserve(img);
        setTimeout(function () {
          var orig = img.getAttribute('data-orig');
          if (orig && img.src !== orig && !(img.complete && img.naturalWidth)) { img.onerror = null; img.src = orig; }
        }, SLOW_MS);
      });
    }, { rootMargin: '200px' }) : null;
    if (slowIO && window.MutationObserver) new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches('img[data-orig]')) slowIO.observe(n);
          n.querySelectorAll('img[data-orig]').forEach(function (i) { slowIO.observe(i); });
        });
      });
    }).observe(root, { childList: true, subtree: true });
    function reviewBodyInner(r) {
      var name = (r.reviewer && r.reviewer.name) || 'Anonymous';
      // header: date on top, then name · verified · stars
      var h = '<div class="npr-card-head"><span class="npr-card-date">' + fmtDate(r.date || r.createdAt) + '</span>' +
        '<span class="npr-card-idrow"><span class="npr-name">' + esc(name) + '</span>';
      if (r.verified) h += '<span class="npr-vb">' + VB_SVG + 'Verified</span>';
      h += '<span class="npr-head-stars">' + starSvgs(r.rating) + '</span></span></div>';
      // review text — clamp + Read more
      h += '<p class="npr-card-text npr-clamp2">' + esc(r.body) + '</p>' +
        '<button type="button" class="npr-more-btn" data-more="Read more" data-less="Show less">Read more</button>';
      // Nordic Park reply — compact, collapsible. Auto-open for sub-4-star reviews so the brand's
      // response to a critical review is visible without a click.
      if (r.reply && r.reply.body) {
        var replyOpen = typeof r.rating === 'number' && r.rating < 4;
        h += '<div class="npr-reply-wrap">' +
          '<button type="button" class="npr-reply-toggle" aria-expanded="' + (replyOpen ? 'true' : 'false') + '"><span class="npr-rt-txt">' + (replyOpen ? 'Hide Nordic Park reply' : 'View Nordic Park reply') + '</span>' +
          '<svg class="npr-rt-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button>' +
          '<div class="npr-reply-collapse' + (replyOpen ? ' is-open' : '') + '"><div class="npr-reply-clip"><div class="npr-reply"><b class="npr-reply-h">Nordic Park:</b> ' + esc(r.reply.body) + '</div></div></div>' +
          '</div>';
      }
      return h;
    }
    // purchased product — separate card child so it can span full width (e.g. split view footer)
    function prodHTML(r) {
      if (!(r.product && r.product.name)) return '';
      var itemType = (window.__NP_LOOX_ITEMTYPES || ITEMTYPES)[r.id] || ''; // read the deferred map live at render time
      // Loox froze each product's url + image when it was first reviewed; the framed-prints launch and the old-id
      // flip deleted many of those images and moved handles. np-loox-products.js (np-artwork/loox-products.mjs)
      // carries the live handle / a working thumbnail for those, read live at render time (deferred script).
      var fix = (window.__NP_LOOX_PRODUCTS || {})[r.product.id] || {};
      var href = fix.h ? '/products/' + fix.h : (r.product.url || '#');
      var img = fix.i ? (/^https?:/.test(fix.i) ? fix.i : 'https://cdn.shopify.com/s/files/1/0825/6824/9689/files/' + fix.i) : r.product.imageUrl;
      var h = '<a class="npr-prod" href="' + esc(href) + '" target="_blank" rel="noopener">';
      if (img) h += '<img class="npr-prod-thumb" loading="lazy" src="' + esc(small(img, 96)) + '" onerror="this.onerror=null;this.removeAttribute(\'src\')" alt="">';
      h += '<span class="npr-prod-info"><span class="npr-prod-name">' + esc(r.product.name) + '</span>';
      if (itemType) h += '<span class="npr-prod-variant">' + esc(fmtVariant(itemType)) + '</span>';
      h += '</span></a>';
      return h;
    }
    function cardHTML(r, idx, flatStart) {
      var media = mediaOf(r);
      var name = (r.reviewer && r.reviewer.name) || 'Anonymous';
      var h = '<article class="npr-card' + (media.length ? '' : ' npr-card--nomedia') + '">';
      if (media.length) {
        h += '<a class="npr-card-media" data-rev="' + idx + '" data-flat="' + flatStart + '">' +
          '<img loading="lazy" src="' + esc(small(media[0], 520)) + '" data-orig="' + esc(media[0]) + '"' + FALLBACK + ' alt="Customer photo by ' + esc(name) + '">';
        if (media.length > 1) h += '<span class="npr-photo-badge">' + CAM_SVG + media.length + ' photos</span>';
        h += '</a>';
      }
      h += '<div class="npr-card-body">' + reviewBodyInner(r) + '</div>' + prodHTML(r) + '</article>';
      return h;
    }

    function showSkeletons() {
      var s = '';
      for (var i = 0; i < 5; i++) s += '<div class="npr-sk"></div>';
      grid.innerHTML = s;
    }

    // Square the customer photo to each card's content height (big for rich reviews, small for short).
    // Thumbnails are a uniform fixed square via CSS (.npr-card-media: 250×250). No per-card sizing.
    function sizeSquares() {}

    // Hide a "Read more"/"Read reply" toggle when its text already fits the 2-line clamp.
    function trimMoreBtns() {
      grid.querySelectorAll('.npr-more-btn').forEach(function (b) {
        var t = b.previousElementSibling;
        if (t && t.classList.contains('npr-clamp2')) {
          b.style.display = (t.scrollHeight - t.clientHeight > 2) ? '' : 'none';
        }
      });
    }

    // Customer photo wall — a strip of the first loaded photos; tap → opens the gallery lightbox.
    var photoStrip = root.querySelector('#nprPhotoStrip');
    var stripDone = false;
    function buildStrip() {
      if (!photoStrip || !allPhotos.length) return;
      var n = Math.min(allPhotos.length, 18), h = '';
      for (var i = 0; i < n; i++) {
        h += '<button type="button" class="npr-strip-thumb" data-flat="' + i + '"><img loading="lazy" src="' + esc(small(allPhotos[i].url, 220)) + '" data-orig="' + esc(allPhotos[i].url) + '"' + FALLBACK + ' alt="Customer photo"></button>';
      }
      h += '<button type="button" class="npr-strip-thumb npr-strip-more" data-flat="0"><span class="npr-strip-more-n">' + esc(PHOTOS_TOTAL || (allPhotos.length + '')) + '</span><span class="npr-strip-more-l">see all</span></button>';
      photoStrip.innerHTML = h;
      photoStrip.hidden = false;
    }

    function load(reset) {
      if (state.loading || (!reset && !state.hasMore)) return;
      state.loading = true;
      emptyEl.hidden = true;
      state.batch = 0;        // reviews rendered in this batch
      state.batchFetches = 0; // API pages fetched this batch (latency cap)
      if (reset) { state.page = 1; state.hasMore = true; state.phase = 1; reviewStore = []; allPhotos = []; stripDone = false; state.firstOfBatch = true; showSkeletons(); }
      else { moreBtn.hidden = true; loadingEl.hidden = false; state.firstOfBatch = false; }
      fetchPage();
    }

    // Pull API pages until the batch holds ~PAGE_SIZE reviews — "photos first" can filter a page right down.
    function fetchPage() {
      state.batchFetches++;
      // np-loox-itemtypes.js is deferred (2026-10-05) and lands after this bundle: re-read the map at fetch time.
      if (window.__NP_LOOX_ITEMTYPES) ITEMTYPES = window.__NP_LOOX_ITEMTYPES;
      fetch(queryURL(), { headers: {} })
        .then(function (res) { return res.json(); })
        .then(function (j) {
          if (state.firstOfBatch) { grid.innerHTML = ''; state.firstOfBatch = false; }
          var list = (j.reviews || []).filter(passesClient);
          var html = '';
          list.forEach(function (r) {
            var idx = reviewStore.length; reviewStore.push(r);
            var flatStart = allPhotos.length;
            mediaOf(r).forEach(function (url) { allPhotos.push({ url: url, revIdx: idx }); });
            html += cardHTML(r, idx, flatStart);
          });
          grid.insertAdjacentHTML('beforeend', html);
          sizeSquares();
          trimMoreBtns();
          state.batch += list.length;
          var apiHasMore = !!(j.pagination && j.pagination.hasMore);
          state.page += 1;
          // "photos first": when phase 1 (photos) is exhausted, continue with the remaining reviews
          if (state.sort === 'photos' && !state.filterPhotos && state.phase === 1 && !apiHasMore) {
            state.phase = 2; state.page = 1; state.hasMore = true;
          } else {
            state.hasMore = apiHasMore;
          }
          // keep pulling until the batch is full (cap fetches to bound latency; allow more when a
          // size/frame filter is active, since matches can be sparse across pages)
          var cap = (state.size || state.frame) ? 14 : 8;
          if (state.batch < PAGE_SIZE && state.hasMore && state.batchFetches < cap) { fetchPage(); return; }
          state.loading = false;
          loadingEl.hidden = true;
          moreBtn.hidden = !state.hasMore;
          emptyEl.hidden = grid.children.length !== 0;
          if (!stripDone && allPhotos.length) { buildStrip(); stripDone = true; } // strip = first full batch's photos
          if (pendingNav && !lb.hidden) {
            pendingNav = false;
            if (lbPos + 1 < allPhotos.length) { lbPos += 1; showLbImg(); } // new photo arrived → advance
            else { showLbImg(); } // phase 1 exhausted, no new photos → re-render so Next can wrap next time
          }
        })
        .catch(function () {
          state.loading = false; loadingEl.hidden = true;
          pendingNav = false; // failed fetch → don't leave the deferred gesture stuck
          if (grid.children.length === 0 || grid.querySelector('.npr-sk')) {
            grid.innerHTML = ''; emptyEl.hidden = false; emptyEl.textContent = 'Could not load reviews. Please refresh.';
          }
        });
    }

    /* ----- filters / sort ----- */
    // Size + Frame chips: single-select per group; combine with each other and with the rating bars.
    function wireChipGroup(id, key) {
      root.querySelector(id).addEventListener('click', function (e) {
        var chip = e.target.closest('.npr-chip'); if (!chip) return;
        root.querySelectorAll(id + ' .npr-chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        state[key] = chip.dataset[key] || null;
        load(true);
      });
    }
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; load(true); });
    moreBtn.addEventListener('click', function () { load(false); });

    /* ----- clickable rating bars → toggle filter by that star (Amazon-style) ----- */
    root.querySelector('#nprBars').addEventListener('click', function (e) {
      var bar = e.target.closest('.npr-bar'); if (!bar) return;
      var r = parseInt(bar.dataset.rating, 10);
      state.rating = (state.rating === r) ? null : r;
      applyBarActive();
      load(true);
    });

    /* ----- photo wall → open the gallery lightbox ----- */
    photoStrip.addEventListener('click', function (e) {
      var t = e.target.closest('.npr-strip-thumb'); if (!t) return;
      openLb(parseInt(t.dataset.flat, 10) || 0);
    });

    /* ----- "Read more" (review text) + "View Nordic Park reply" toggles (cards + lightbox) ----- */
    root.addEventListener('click', function (e) {
      var rt = e.target.closest('.npr-reply-toggle');
      if (rt) {
        var open = rt.nextElementSibling.classList.toggle('is-open');
        rt.setAttribute('aria-expanded', open ? 'true' : 'false');
        rt.querySelector('.npr-rt-txt').textContent = open ? 'Hide Nordic Park reply' : 'View Nordic Park reply';
        return;
      }
      var b = e.target.closest('.npr-more-btn'); if (!b) return;
      var text = b.previousElementSibling; if (!text) return;
      var clamped = text.classList.toggle('npr-clamp2');
      b.textContent = clamped ? b.dataset.more : b.dataset.less;
    });

    /* ----- re-square photos on resize ----- */
    var rsTimer;
    window.addEventListener('resize', function () { clearTimeout(rsTimer); rsTimer = setTimeout(function () { sizeSquares(); trimMoreBtns(); }, 150); });

    /* ----- lightbox: a gallery over ALL loaded customer photos, with zoom + pan + swipe ----- */
    var lb = root.querySelector('#nprLb'), lbImg = root.querySelector('#nprLbImg');
    var lbInfo = root.querySelector('#nprLbInfo'), lbCount = root.querySelector('#nprLbCount');
    var lbPrev = root.querySelector('#nprLbPrev'), lbNext = root.querySelector('#nprLbNext');
    var lbMedia = root.querySelector('.npr-lb-media');
    var lbPanel = root.querySelector('.npr-lb-panel');
    var lbPos = 0;
    var pendingNav = false; // a Next/forward gesture at the loading boundary, applied when photos land
    // are more PHOTOS still coming? ("photos first" loads all photos in phase 1, then photo-less reviews
    // in phase 2 — so once phase 1 is done there are no more photos to fetch for the gallery)
    function morePhotosComing() {
      return state.sort === 'photos' ? (state.phase === 1 && state.hasMore) : state.hasMore;
    }

    /* zoom/pan state for the current photo */
    var z = { s: 1, x: 0, y: 0 };
    function applyZoom() {
      lbImg.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
      lbImg.style.cursor = z.s > 1 ? 'grab' : 'zoom-in';
    }
    function clampPan() {
      var mx = Math.max(0, (z.s - 1) * lbImg.offsetWidth / 2);
      var my = Math.max(0, (z.s - 1) * lbImg.offsetHeight / 2);
      z.x = Math.max(-mx, Math.min(mx, z.x));
      z.y = Math.max(-my, Math.min(my, z.y));
    }
    function setScale(ns) {
      z.s = Math.max(1, Math.min(4, ns));
      if (z.s === 1) { z.x = 0; z.y = 0; }
      clampPan(); applyZoom();
    }
    function resetZoom() { z.s = 1; z.x = 0; z.y = 0; lbImg.style.transition = ''; applyZoom(); }

    function showLbImg() {
      var p = allPhotos[lbPos]; if (!p) return;
      lbImg.src = p.url;
      var r = reviewStore[p.revIdx];
      lbInfo.innerHTML = reviewBodyInner(r) + prodHTML(r);
      // lightbox shows full text/reply — drop the clamps + toggles
      lbInfo.querySelectorAll('.npr-clamp2').forEach(function (el) { el.classList.remove('npr-clamp2'); });
      lbInfo.querySelectorAll('.npr-more-btn').forEach(function (b) { b.style.display = 'none'; });
      lbInfo.querySelectorAll('.npr-reply-collapse').forEach(function (c) { c.classList.add('is-open'); });
      lbInfo.querySelectorAll('.npr-reply-toggle').forEach(function (b) { b.style.display = 'none'; });
      var multi = allPhotos.length > 1 || state.hasMore;
      lbPrev.hidden = !multi; lbNext.hidden = !multi; lbCount.hidden = !multi;
      // show the TRUE total (e.g. "12 / 1,000+") for trust, falling back to the loaded count
      if (multi) lbCount.textContent = (lbPos + 1) + ' / ' + (PHOTOS_TOTAL || allPhotos.length);
      resetZoom();
      lbPanel.scrollTop = 0;
      // keep loading more photos as the user nears the end so they can browse (nearly) all of them
      if (morePhotosComing() && !state.loading && (allPhotos.length - lbPos) <= 8) load(false);
    }
    function openLb(flatIdx) {
      if (!allPhotos.length) return;
      lbPos = Math.max(0, Math.min(allPhotos.length - 1, flatIdx || 0));
      showLbImg();
      lb.hidden = false; document.body.style.overflow = 'hidden';
    }
    function closeLb() { lb.hidden = true; document.body.style.overflow = ''; resetZoom(); }
    function nav(d) {
      if (!allPhotos.length) return;
      var next = lbPos + d;
      if (next < 0) next = allPhotos.length - 1;            // wrap to the end
      else if (next >= allPhotos.length) {
        if (morePhotosComing()) { pendingNav = true; load(false); return; } // defer; advance when photos land
        next = 0;                                            // true end → wrap to the start
      }
      lbPos = next; showLbImg();
    }

    grid.addEventListener('click', function (e) {
      var m = e.target.closest('.npr-card-media'); if (!m) return;
      e.preventDefault();
      openLb(parseInt(m.dataset.flat, 10) || 0);
    });
    root.querySelector('#nprLbClose').addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); nav(-1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); nav(1); });
    root.querySelector('#nprLbBackdrop').addEventListener('click', closeLb);
    root.querySelector('#nprLbZoomIn').addEventListener('click', function (e) { e.stopPropagation(); setScale(z.s + 0.6); });
    root.querySelector('#nprLbZoomOut').addEventListener('click', function (e) { e.stopPropagation(); setScale(z.s - 0.6); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') nav(-1);
      else if (e.key === 'ArrowRight') nav(1);
      else if (e.key === '+' || e.key === '=') setScale(z.s + 0.4);
      else if (e.key === '-') setScale(z.s - 0.4);
    });

    /* desktop: wheel to zoom, double-click to toggle, drag to pan */
    lbMedia.addEventListener('wheel', function (e) {
      if (lb.hidden) return;
      e.preventDefault();
      setScale(z.s * (e.deltaY < 0 ? 1.18 : 0.85));
    }, { passive: false });
    lbImg.addEventListener('dblclick', function (e) { e.preventDefault(); setScale(z.s > 1 ? 1 : 2.5); });
    var mDrag = false, mSX, mSY, mOX, mOY;
    lbImg.addEventListener('mousedown', function (e) {
      if (z.s <= 1) return;
      e.preventDefault(); mDrag = true; mSX = e.clientX; mSY = e.clientY; mOX = z.x; mOY = z.y;
      lbImg.style.transition = 'none'; lbImg.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', function (e) {
      if (!mDrag) return;
      z.x = mOX + (e.clientX - mSX); z.y = mOY + (e.clientY - mSY); clampPan(); applyZoom();
    });
    window.addEventListener('mouseup', function () { if (mDrag) { mDrag = false; lbImg.style.transition = ''; lbImg.style.cursor = z.s > 1 ? 'grab' : 'zoom-in'; } });

    /* touch: pinch-zoom, 1-finger pan when zoomed, horizontal swipe to change photo,
       vertical drag scrolls the panel, double-tap to toggle zoom */
    var tp = {};
    function tDist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    lbMedia.addEventListener('touchstart', function (e) {
      lbImg.style.transition = 'none';
      if (e.touches.length === 2) {
        tp.pinch = true; tp.d0 = tDist(e.touches[0], e.touches[1]); tp.s0 = z.s; e.preventDefault();
      } else if (e.touches.length === 1) {
        tp.pinch = false; tp.sx = e.touches[0].clientX; tp.sy = e.touches[0].clientY;
        tp.ox = z.x; tp.oy = z.y; tp.dir = null; tp.dx = 0; tp.scroll0 = lbPanel.scrollTop;
        var now = Date.now();
        if (now - (tp.lastTap || 0) < 300) { e.preventDefault(); setScale(z.s > 1 ? 1 : 2.5); tp.lastTap = 0; }
        else { tp.lastTap = now; }
      }
    }, { passive: false });
    lbMedia.addEventListener('touchmove', function (e) {
      if (tp.pinch && e.touches.length === 2) {
        e.preventDefault(); setScale(tp.s0 * (tDist(e.touches[0], e.touches[1]) / tp.d0)); return;
      }
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - tp.sx, dy = e.touches[0].clientY - tp.sy;
      if (z.s > 1) { e.preventDefault(); z.x = tp.ox + dx; z.y = tp.oy + dy; clampPan(); applyZoom(); return; }
      if (!tp.dir && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) tp.dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      if (tp.dir === 'h') { e.preventDefault(); tp.dx = dx; }
      else if (tp.dir === 'v') { e.preventDefault(); lbPanel.scrollTop = tp.scroll0 - dy; }
    }, { passive: false });
    lbMedia.addEventListener('touchend', function () {
      lbImg.style.transition = '';
      if (tp.pinch) { tp.pinch = false; if (z.s < 1.05) resetZoom(); return; }
      if (z.s <= 1 && tp.dir === 'h' && Math.abs(tp.dx) > 45) nav(tp.dx < 0 ? 1 : -1);
      tp.dir = null; tp.dx = 0;
    });

    /* ----- go ----- */
    buildFilters();
    buildSummary();
    load(true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["np-reviews-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.npr-root');
    if (!root || root.dataset.nprInit) return;
    root.dataset.nprInit = '1';

    var STORE = root.dataset.storeId;
    var PAGE_SIZE = parseInt(root.dataset.pageSize, 10) || 20;
    var PHOTOS_TOTAL = (root.dataset.photosCount || '').trim(); // e.g. "1,000+" — shown as the lightbox total (ALL scope)
    var PRODUCT_ID = (root.dataset.productId || '').trim();      // numeric Shopify id; Loox uses it as product_id
    var PRODUCT_HANDLE = (root.dataset.productHandle || '').trim();
    var PRODUCT_TITLE = (root.dataset.productTitle || 'this artwork').trim();
    var THRESHOLD = 2;   // 2026-09-29 (Ollie): opens on "This artwork" from 2 reviews up, whatever the average (was the section setting, 4, AND avg >= 4.5)
    var FAM_AVG = parseFloat(root.dataset.famAvg) || 0;   // pooled artwork average (metafield) — no longer gates the default scope
    function roundAll(n) { return (Math.floor(n / 10) * 10).toLocaleString() + '+'; }   // store-wide figure floored to 10, like np-reviews-total (Ollie 2026-10-04; was 100)
    // "This artwork" = this artwork across ALL its shape variants. IDs come from the shape_group
    // metaobject (window.__NP_SHAPE_GROUP_IDS, emitted server-side). Falls back to just this product.
    var GROUP_IDS = (window.__NP_SHAPE_GROUP_IDS && window.__NP_SHAPE_GROUP_IDS.length) ? window.__NP_SHAPE_GROUP_IDS.slice() : (PRODUCT_ID ? [parseInt(PRODUCT_ID, 10)] : []);
    // each product id once: a repeated id double-counts its reviews (2026-10-11: Whispering Petals showed 359 for 218)
    GROUP_IDS = GROUP_IDS.filter(function (id, i) { return GROUP_IDS.indexOf(id) === i; });
    var IS_GROUP = GROUP_IDS.length > 1;
    var BASE = 'https://storefront-api.loox.io/storefront/v1/store/' + STORE + '/product-reviews';
    var GOLD = 'npr-star-on', OFF = 'npr-star-off';

    var grid = root.querySelector('#nprGrid');
    var moreBtn = root.querySelector('#nprMore');
    var loadingEl = root.querySelector('#nprLoading');
    var emptyEl = root.querySelector('#nprEmpty');
    var sortSel = root.querySelector('#nprSort');
    var scopeEl = root.querySelector('#nprScope');
    var scopeNote = root.querySelector('#nprScopeNote');

    // scope: 'product' (this product only) or 'all' (store-wide). Set after counts are known.
    var productCount = 0, storeCount = 0;
    // sort 'photos' = "Newest (photos first)": photo reviews first (phase 1), then the rest (phase 2).
    var state = { scope: 'all', sort: 'photos', rating: null, filterPhotos: false, size: null, frame: null, phase: 1, page: 1, hasMore: true, loading: false };
    function pidParam() { return state.scope === 'product' && PRODUCT_ID ? '&product_id=' + PRODUCT_ID : ''; }

    /* ----- helpers ----- */
    function starSvgs(r) {
      // Same fractional ★ glyph as the collection tiles / PDP badge (np-stars) so the star shape is
      // identical across the whole site. Filled = solid gold, empty = hollow gold outline.
      var rHalf = Math.round((Number(r) || 0) * 2) / 2; // snap to nearest half star (Amazon-style)
      var pct = Math.max(0, Math.min(100, rHalf / 5 * 100));
      return '<span class="npr-fstars"><span class="npr-fstars-t">★★★★★</span><span class="npr-fstars-f" style="width:' + pct + '%">★★★★★</span></span>';
    }
    function starsHTML(r) { return '<span class="npr-stars">' + starSvgs(r) + '</span>'; }
    function initials(name) {
      if (!name) return '?';
      var p = name.replace(/[^A-Za-z .]/g, '').trim().split(/\s+/);
      return ((p[0] ? p[0][0] : '') + (p[1] ? p[1][0] : '')).toUpperCase() || '?';
    }
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    function fmtDate(s) { // US format: "Jun 26, 2026"
      var d = new Date(s); if (isNaN(d)) return '';
      return MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
    }
    function esc(s) { var e = document.createElement('div'); e.textContent = s == null ? '' : s; return e.innerHTML; }
    var ITEMTYPES = window.__NP_LOOX_ITEMTYPES || {}; // { reviewId: "30 x 30 Inches / Oak Floating Frame" }
    function fmtVariant(v) { // "30 x 30 Inches / Oak Floating Frame" -> "30 × 30 in · Oak Floating Frame"
      return v.replace(/(\d)\s*x\s*(\d)/i, '$1 × $2').replace(/\s*Inches/i, ' in').replace(/\s*\/\s*/, ' · ');
    }

    /* ----- size / frame parsing for the filters (from the item-type map) ----- */
    // longest side → bucket. Catalog longest sides run ~20–58".
    var SIZE_BUCKETS = [
      { key: 'S', label: 'Small', max: 24 },
      { key: 'M', label: 'Medium', max: 32 },
      { key: 'L', label: 'Large', max: 40 },
      { key: 'XL', label: 'Extra Large', max: Infinity }
    ];
    function parseVariant(v) {
      var parts = (v || '').split('/');
      var nums = (parts[0] || '').match(/\d+(\.\d+)?/g);
      return { longest: nums ? Math.max.apply(null, nums.map(Number)) : 0, frame: (parts[1] || '').trim() };
    }
    function sizeBucketOf(v) {
      var n = parseVariant(v).longest; if (!n) return null;
      for (var i = 0; i < SIZE_BUCKETS.length; i++) if (n <= SIZE_BUCKETS[i].max) return SIZE_BUCKETS[i].key;
      return null;
    }
    function frameOf(v) { return parseVariant(v).frame; }
    function frameShort(f) { return f.replace(/Stretched Canvas Only/i, 'Canvas').replace(/\s*Floating Frame$/i, '').trim() || f; }

    // Build the Size + Frame chips from a list of variant strings (real counts).
    var productFiltersDone = false;
    function buildFiltersFrom(variants) {
      var sizeCounts = {}, frameCounts = {};
      variants.forEach(function (v) {
        if (typeof v !== 'string') return;
        var b = sizeBucketOf(v); if (b) sizeCounts[b] = (sizeCounts[b] || 0) + 1;
        var f = frameOf(v); if (f) frameCounts[f] = (frameCounts[f] || 0) + 1;
      });
      var sh = '<button class="npr-chip is-active" data-size="">Any size</button>';
      SIZE_BUCKETS.forEach(function (b) {
        if (!sizeCounts[b.key]) return;
        sh += '<button class="npr-chip" data-size="' + b.key + '">' + b.label + ' <span class="npr-chip-ct">' + sizeCounts[b.key].toLocaleString() + '</span></button>';
      });
      root.querySelector('#nprSizeChips').innerHTML = sh;
      var fh = '<button class="npr-chip is-active" data-frame="">Any frame</button>';
      Object.keys(frameCounts).sort(function (a, b) { return frameCounts[b] - frameCounts[a]; }).forEach(function (f) {
        fh += '<button class="npr-chip" data-frame="' + esc(f) + '">' + esc(frameShort(f)) + ' <span class="npr-chip-ct">' + frameCounts[f].toLocaleString() + '</span></button>';
      });
      root.querySelector('#nprFrameChips').innerHTML = fh;
    }
    // ALL scope: from the full baked map. PRODUCT scope: from this product's loaded reviews.
    function buildFiltersAll() { buildFiltersFrom(Object.keys(ITEMTYPES).map(function (k) { return ITEMTYPES[k]; })); }
    function buildFiltersProduct() { buildFiltersFrom(reviewStore.map(function (r) { return ITEMTYPES[r.id]; })); }

    /* ----- summary ----- */
    function countsOf(arr) {
      var c = [0, 0, 0, 0, 0];
      arr.forEach(function (r) { var rt = Math.round(r.rating); if (rt >= 1 && rt <= 5) c[rt - 1]++; });
      return c;
    }
    // Render the summary band from a [r1,r2,r3,r4,r5] count array (used by both scopes).
    function renderSummary(counts) {
      var bars = root.querySelector('#nprBars');
      var summaryEl = root.querySelector('.npr-summary');
      var total = counts.reduce(function (a, b) { return a + b; }, 0);
      bars.innerHTML = '';
      // 0 reviews in scope → hide the whole summary band (no confusing "—/5"); empty state carries the message.
      if (summaryEl) summaryEl.hidden = !total;
      if (!total) return;
      var sum = counts.reduce(function (a, c, i) { return a + c * (i + 1); }, 0);
      var avg = (sum / total);
      root.querySelector('#nprAvg').textContent = avg.toFixed(1);
      root.querySelector('#nprAvgStars').innerHTML = starSvgs(avg);
      // ALL scope = rounded "3,325+"; PRODUCT/group scope = the exact count (no "+")
      root.querySelector('#nprTotal').textContent = state.scope === 'all' ? roundAll(total) : total.toLocaleString();
      root.querySelector('#nprPct').textContent = '91%'; // static brand-wide figure (NOT per-product)
      var rows = '';
      for (var s = 5; s >= 1; s--) {
        var c = counts[s - 1];
        var pct = total ? (c / total * 100) : 0;
        rows += '<button type="button" class="npr-bar" data-rating="' + s + '">' +
          '<span class="npr-bar-lbl">' + s + ' star</span>' +
          '<span class="npr-bar-track"><span class="npr-bar-fill" style="width:' + pct.toFixed(1) + '%"></span></span>' +
          '<span class="npr-bar-ct">' + c.toLocaleString() + ' (<span class="npr-bar-pct">' + Math.round(pct) + '%</span>)</span>' +
          '</button>';
      }
      bars.insertAdjacentHTML('afterbegin', rows);
      applyBarActive();
    }
    // ALL scope: rating distribution from 5 count-calls.
    function buildSummary() {
      var calls = [1, 2, 3, 4, 5].map(function (r) {
        return fetch(BASE + '?rating=' + r + '&limit=1', { headers: {} })
          .then(function (res) { return res.json(); })
          .then(function (j) { return (j.pagination && j.pagination.total) || 0; })
          .catch(function () { return 0; });
      });
      Promise.all(calls).then(renderSummary);
    }
    function applyBarActive() {
      root.querySelectorAll('.npr-bar').forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.rating, 10) === state.rating);
      });
    }

    /* ----- trust + avg-stars icons ----- */
    var TRUST_ICONS = [
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="8.5" cy="9.5" r="1.5"/><path d="m21 16-5-5L5 20"/></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M21 8 12 3 3 8l9 5 9-5Z"/><path d="M3 8v8l9 5 9-5V8M12 13v8"/></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M1 4h13v12H1zM14 8h4l3 3v5h-7"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M12 2 4 5v6c0 5 3.4 8.4 8 11 4.6-2.6 8-6 8-11V5Z"/><path d="m9 12 2 2 4-4"/></svg>'
    ];
    root.querySelectorAll('.npr-trust-ico').forEach(function (el) { el.innerHTML = TRUST_ICONS[el.dataset.ico] || ''; });

    /* ----- fetch + render reviews ----- */
    function queryURL() {
      var srt = state.sort === 'photos' ? 'date' : state.sort; // "Newest photos" = newest, photo-filtered
      var p = 'sort=' + srt + '&limit=' + PAGE_SIZE + '&page=' + state.page;
      if (state.rating) p += '&rating=' + state.rating;
      return BASE + '?' + p + pidParam(); // pidParam adds &product_id in product scope
    }
    function passesClient(r) {
      var hasPhoto = !!(r.media && r.media.length);
      if (state.filterPhotos && !hasPhoto) return false;            // "With photos" chip = photo-only
      // size / frame filters (from the baked item-type map; reviews not in the map can't match a filter)
      if (state.size || state.frame) {
        var v = ITEMTYPES[r.id]; if (!v) return false;
        if (state.size && sizeBucketOf(v) !== state.size) return false;
        if (state.frame && frameOf(v) !== state.frame) return false;
      }
      if (state.sort === 'photos' && !state.filterPhotos) {         // "photos first" 2-phase ordering
        if (state.phase === 1 && !hasPhoto) return false;
        if (state.phase === 2 && hasPhoto) return false;            // phase 2 = the remaining (non-photo) reviews
      }
      return true;
    }

    var reviewStore = []; // full review objects, indexed for the lightbox
    var allPhotos = [];   // flat list of every loaded customer photo: {url, revIdx} — the lightbox browses this
    var VB_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2 4 5v6c0 5 3.4 8.4 8 11 4.6-2.6 8-6 8-11V5Z" opacity=".18"/><path fill="none" stroke="currentColor" stroke-width="1.6" d="M12 2 4 5v6c0 5 3.4 8.4 8 11 4.6-2.6 8-6 8-11V5Z"/><path fill="none" stroke="currentColor" stroke-width="1.7" d="m9 12 2 2 4-4"/></svg>';
    var CAM_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg>';

    function mediaOf(r) {
      return (r.media || []).filter(function (m) { return m.type === 'photo' && m.url; }).map(function (m) { return m.url; });
    }
    /* Small copies for thumbnails (2026-10-05). Loox only serves the ORIGINAL upload (0.5-1 MB each) and offers no
       thumbnail URL, so customer photos in the strip and on the cards go through a resizer (WebP, ~3-15 KB);
       Shopify product thumbs just get ?width=. The lightbox always opens the original (lbImg.src = p.url).
       If the resizer ever fails, onerror swaps the original back in. Swap IMG_PROXY for our own route later. */
    var IMG_PROXY = 'https://wsrv.nl/?url=';
    function small(url, w) {
      if (!url) return '';
      if (/^(https?:)?\/\/(cdn\.shopify\.com|[a-z0-9.-]*nordicpark\.co)\//i.test(url)) return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      return IMG_PROXY + encodeURIComponent(url.replace(/^https?:\/\//, '')) + '&w=' + w + '&q=75&output=webp';
    }
    var FALLBACK = ' onerror="this.onerror=null;this.src=this.getAttribute(\'data-orig\')"';
    /* Watchdog (2026-10-06): the resizer can STALL on a cold photo (seen 21 s) without erroring, so onerror never
       fires and the card sits blank. Once a resized photo is on screen, give it 4 s, then load the original. */
    var SLOW_MS = 4000;
    var slowIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        var img = e.target; slowIO.unobserve(img);
        setTimeout(function () {
          var orig = img.getAttribute('data-orig');
          if (orig && img.src !== orig && !(img.complete && img.naturalWidth)) { img.onerror = null; img.src = orig; }
        }, SLOW_MS);
      });
    }, { rootMargin: '200px' }) : null;
    if (slowIO && window.MutationObserver) new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches('img[data-orig]')) slowIO.observe(n);
          n.querySelectorAll('img[data-orig]').forEach(function (i) { slowIO.observe(i); });
        });
      });
    }).observe(root, { childList: true, subtree: true });
    function reviewBodyInner(r) {
      var name = (r.reviewer && r.reviewer.name) || 'Anonymous';
      // header: date on top, then name · verified · stars
      var h = '<div class="npr-card-head"><span class="npr-card-date">' + fmtDate(r.date || r.createdAt) + '</span>' +
        '<span class="npr-card-idrow"><span class="npr-name">' + esc(name) + '</span>';
      if (r.verified) h += '<span class="npr-vb">' + VB_SVG + 'Verified</span>';
      h += '<span class="npr-head-stars">' + starSvgs(r.rating) + '</span></span></div>';
      // review text — clamp + Read more
      h += '<p class="npr-card-text npr-clamp2">' + esc(r.body) + '</p>' +
        '<button type="button" class="npr-more-btn" data-more="Read more" data-less="Show less">Read more</button>';
      // Nordic Park reply — compact, collapsible. Auto-open for sub-4-star reviews so the brand's
      // response to a critical review is visible without a click.
      if (r.reply && r.reply.body) {
        var replyOpen = typeof r.rating === 'number' && r.rating < 4;
        h += '<div class="npr-reply-wrap">' +
          '<button type="button" class="npr-reply-toggle" aria-expanded="' + (replyOpen ? 'true' : 'false') + '"><span class="npr-rt-txt">' + (replyOpen ? 'Hide Nordic Park reply' : 'View Nordic Park reply') + '</span>' +
          '<svg class="npr-rt-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></button>' +
          '<div class="npr-reply-collapse' + (replyOpen ? ' is-open' : '') + '"><div class="npr-reply-clip"><div class="npr-reply"><b class="npr-reply-h">Nordic Park:</b> ' + esc(r.reply.body) + '</div></div></div>' +
          '</div>';
      }
      return h;
    }
    // purchased product — separate card child so it can span full width (e.g. split view footer)
    function prodHTML(r) {
      if (!(r.product && r.product.name)) return '';
      var itemType = ITEMTYPES[r.id] || '';
      // Loox froze each product's url + image when it was first reviewed; the framed-prints launch and the old-id
      // flip deleted many of those images and moved handles. np-loox-products.js (np-artwork/loox-products.mjs)
      // carries the live handle / a working thumbnail for those, read live at render time (deferred script).
      var fix = (window.__NP_LOOX_PRODUCTS || {})[r.product.id] || {};
      var href = fix.h ? '/products/' + fix.h : (r.product.url || '#');
      var img = fix.i ? (/^https?:/.test(fix.i) ? fix.i : 'https://cdn.shopify.com/s/files/1/0825/6824/9689/files/' + fix.i) : r.product.imageUrl;
      var h = '<a class="npr-prod" href="' + esc(href) + '" target="_blank" rel="noopener">';
      if (img) h += '<img class="npr-prod-thumb" loading="lazy" src="' + esc(small(img, 96)) + '" onerror="this.onerror=null;this.removeAttribute(\'src\')" alt="">';
      h += '<span class="npr-prod-info"><span class="npr-prod-name">' + esc(r.product.name) + '</span>';
      if (itemType) h += '<span class="npr-prod-variant">' + esc(fmtVariant(itemType)) + '</span>';
      h += '</span></a>';
      return h;
    }
    function cardHTML(r, idx, flatStart) {
      var media = mediaOf(r);
      var name = (r.reviewer && r.reviewer.name) || 'Anonymous';
      var h = '<article class="npr-card' + (media.length ? '' : ' npr-card--nomedia') + '">';
      if (media.length) {
        h += '<a class="npr-card-media" data-rev="' + idx + '" data-flat="' + flatStart + '">' +
          '<img loading="lazy" src="' + esc(small(media[0], 520)) + '" data-orig="' + esc(media[0]) + '"' + FALLBACK + ' alt="Customer photo by ' + esc(name) + '">';
        if (media.length > 1) h += '<span class="npr-photo-badge">' + CAM_SVG + media.length + ' photos</span>';
        h += '</a>';
      }
      h += '<div class="npr-card-body">' + reviewBodyInner(r) + '</div>' + prodHTML(r) + '</article>';
      return h;
    }

    function showSkeletons() {
      var s = '';
      for (var i = 0; i < 5; i++) s += '<div class="npr-sk"></div>';
      grid.innerHTML = s;
    }

    // Square the customer photo to each card's content height (big for rich reviews, small for short).
    // Thumbnails are a uniform fixed square via CSS (.npr-card-media: 250×250). No per-card sizing.
    function sizeSquares() {}

    // Hide a "Read more"/"Read reply" toggle when its text already fits the 2-line clamp.
    function trimMoreBtns() {
      grid.querySelectorAll('.npr-more-btn').forEach(function (b) {
        var t = b.previousElementSibling;
        if (t && t.classList.contains('npr-clamp2')) {
          b.style.display = (t.scrollHeight - t.clientHeight > 2) ? '' : 'none';
        }
      });
    }

    // ALL scope → configured "1,000+"; PRODUCT scope → the loaded (≈ exact) product photo count.
    function photoTotalLabel() {
      if (state.scope === 'all' && PHOTOS_TOTAL) return PHOTOS_TOTAL;
      if (state.scope === 'product') {
        var src = groupView.length ? groupView : groupReviews;
        var n = src.filter(function (r) { return r.media && r.media.length; }).length;
        return (n || allPhotos.length) + '';
      }
      return allPhotos.length + '';
    }

    // Customer photo wall — a strip of the first loaded photos; tap → opens the gallery lightbox.
    var photoStrip = root.querySelector('#nprPhotoStrip');
    var stripWrap = root.querySelector('#nprStripWrap');
    var stripPrev = root.querySelector('#nprStripPrev');
    var stripNext = root.querySelector('#nprStripNext');
    var stripDone = false;
    function updateStripNav() {
      if (!stripWrap || stripWrap.hidden) return;
      var overflow = photoStrip.scrollWidth - photoStrip.clientWidth;
      if (overflow <= 4) { stripPrev.hidden = true; stripNext.hidden = true; return; }
      stripPrev.hidden = photoStrip.scrollLeft <= 2;
      stripNext.hidden = photoStrip.scrollLeft >= overflow - 2;
    }
    function buildStrip() {
      if (!photoStrip || !stripWrap) return;
      if (!allPhotos.length) { stripWrap.hidden = true; return; } // no photos in this scope → hide the wall
      // one photo per customer (Ollie 2 Nov): a review's extra photos, and a second review from the same name, were filling the
      // wall with near-identical shots. The lightbox still browses every photo — data-flat points at the kept one.
      var h = '', shown = 0, seenRev = {}, seenName = {};
      for (var i = 0; i < allPhotos.length && shown < 18; i++) {
        var p = allPhotos[i], rv = reviewStore[p.revIdx] || {}, nm = ((rv.reviewer && rv.reviewer.name) || '').trim().toLowerCase();
        if (seenRev[p.revIdx] || (nm && nm !== 'anonymous' && seenName[nm])) continue;
        seenRev[p.revIdx] = 1; if (nm) seenName[nm] = 1; shown++;
        h += '<button type="button" class="npr-strip-thumb" data-flat="' + i + '"><img loading="lazy" src="' + esc(small(p.url, 220)) + '" data-orig="' + esc(p.url) + '"' + FALLBACK + ' alt="Customer photo"></button>';
      }
      h += '<button type="button" class="npr-strip-thumb npr-strip-more" data-flat="0"><span class="npr-strip-more-n">' + esc(photoTotalLabel()) + '</span><span class="npr-strip-more-l">see all</span></button>';
      photoStrip.innerHTML = h;
      stripWrap.hidden = false;
      photoStrip.scrollLeft = 0;
      updateStripNav();
    }

    // Scope-aware empty state (+ "write the first review" when a product has none).
    function updateEmptyState() {
      var empty = grid.children.length === 0;
      emptyEl.hidden = !empty;
      if (!empty) return;
      var msg = root.querySelector('#nprEmptyMsg'), wbtn = root.querySelector('#nprWrite');
      var filtered = !!(state.size || state.frame || state.rating);
      if (state.scope === 'product' && !filtered) {
        if (msg) msg.textContent = 'No reviews yet for this artwork — be the first to share yours.';
        if (wbtn) wbtn.hidden = false;
      } else {
        if (msg) msg.textContent = state.scope === 'product' ? 'No reviews of this artwork match those filters.' : 'No reviews match this filter.';
        if (wbtn) wbtn.hidden = true;
      }
    }

    /* ----- "This artwork" = the artwork across all its shape variants (Loox group):
            fetch every group product's reviews, merge, render + summarise client-side ----- */
    var groupReviews = [], groupView = [], groupShown = 0;
    function fetchAllForProduct(pid) {
      return new Promise(function (resolve) {
        var acc = [], page = 1;
        (function go() {
          fetch(BASE + '?sort=date&limit=50&page=' + page + '&product_id=' + pid, { headers: {} })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              acc = acc.concat(j.reviews || []);
              if (j.pagination && j.pagination.hasMore && page < 12) { page++; go(); }
              else resolve(acc);
            }).catch(function () { resolve(acc); });
        })();
      });
    }
    function sortGroup(arr) {
      var byDate = arr.slice().sort(function (a, b) { return new Date(b.date || b.createdAt) - new Date(a.date || a.createdAt); });
      if (state.sort === 'photos') {
        var withP = byDate.filter(function (r) { return r.media && r.media.length; });
        var noP = byDate.filter(function (r) { return !(r.media && r.media.length); });
        return withP.concat(noP);
      }
      return byDate;
    }
    function refreshGroupView() {
      groupView = sortGroup(state.rating ? groupReviews.filter(function (r) { return Math.round(r.rating) === state.rating; }) : groupReviews);
      groupShown = 0; reviewStore = []; allPhotos = []; stripDone = false;
      grid.innerHTML = '';
      renderGroupSlice();
    }
    function renderGroupSlice() {
      var end = Math.min(groupShown + PAGE_SIZE, groupView.length), html = '';
      for (var i = groupShown; i < end; i++) {
        var r = groupView[i]; var idx = reviewStore.length; reviewStore.push(r);
        var flatStart = allPhotos.length;
        mediaOf(r).forEach(function (url) { allPhotos.push({ url: url, revIdx: idx }); });
        html += cardHTML(r, idx, flatStart);
      }
      grid.insertAdjacentHTML('beforeend', html);
      groupShown = end;
      trimMoreBtns();
      if (!stripDone) { buildStrip(); stripDone = true; }
      moreBtn.hidden = groupShown >= groupView.length;
      loadingEl.hidden = true;
      updateEmptyState();
    }
    function loadGroup(reset) {
      if (!reset) { renderGroupSlice(); return; }                 // load more = client-side slice
      if (groupReviews.length) { renderSummary(countsOf(groupReviews)); refreshGroupView(); return; } // filter/sort = re-view
      if (state.loading) return;
      state.loading = true; emptyEl.hidden = true; showSkeletons();
      Promise.all(GROUP_IDS.map(fetchAllForProduct)).then(function (lists) {
        var all = [].concat.apply([], lists), seen = {};
        all = all.filter(function (r) { if (seen[r.id]) return false; seen[r.id] = 1; return true; });
        groupReviews = all;
        renderSummary(countsOf(groupReviews));
        state.loading = false;
        refreshGroupView();
      }).catch(function () {
        state.loading = false; loadingEl.hidden = true;
        grid.innerHTML = ''; emptyEl.hidden = false;
        var em = root.querySelector('#nprEmptyMsg'); if (em) em.textContent = 'Could not load reviews. Please refresh.';
      });
    }

    function load(reset) {
      // The item-type map (np-loox-itemtypes.js) is a deferred script that loads AFTER this
      // bundle initialises, so the init-time capture of ITEMTYPES can be empty. load() runs on
      // scroll-into-view (well after all deferred scripts), so refresh from the live global here.
      if (window.__NP_LOOX_ITEMTYPES) ITEMTYPES = window.__NP_LOOX_ITEMTYPES;
      if (state.scope === 'product') { loadGroup(reset); return; } // "This artwork" → group path
      if (state.loading || (!reset && !state.hasMore)) return;
      state.loading = true;
      emptyEl.hidden = true;
      state.batch = 0;        // reviews rendered in this batch
      state.batchFetches = 0; // API pages fetched this batch (latency cap)
      if (reset) { state.page = 1; state.hasMore = true; state.phase = 1; reviewStore = []; allPhotos = []; stripDone = false; state.firstOfBatch = true; showSkeletons(); }
      else { moreBtn.hidden = true; loadingEl.hidden = false; state.firstOfBatch = false; }
      fetchPage();
    }

    // Pull API pages until the batch holds ~PAGE_SIZE reviews — "photos first" can filter a page right down.
    function fetchPage() {
      state.batchFetches++;
      fetch(queryURL(), { headers: {} })
        .then(function (res) { return res.json(); })
        .then(function (j) {
          if (state.firstOfBatch) { grid.innerHTML = ''; state.firstOfBatch = false; }
          var list = (j.reviews || []).filter(passesClient);
          var html = '';
          list.forEach(function (r) {
            var idx = reviewStore.length; reviewStore.push(r);
            var flatStart = allPhotos.length;
            mediaOf(r).forEach(function (url) { allPhotos.push({ url: url, revIdx: idx }); });
            html += cardHTML(r, idx, flatStart);
          });
          grid.insertAdjacentHTML('beforeend', html);
          sizeSquares();
          trimMoreBtns();
          state.batch += list.length;
          var apiHasMore = !!(j.pagination && j.pagination.hasMore);
          state.page += 1;
          // "photos first": when phase 1 (photos) is exhausted, continue with the remaining reviews
          if (state.sort === 'photos' && !state.filterPhotos && state.phase === 1 && !apiHasMore) {
            state.phase = 2; state.page = 1; state.hasMore = true;
          } else {
            state.hasMore = apiHasMore;
          }
          // keep pulling until the batch is full (cap fetches to bound latency; allow more when a
          // size/frame filter is active, since matches can be sparse across pages)
          var cap = (state.size || state.frame) ? 14 : 8;
          if (state.batch < PAGE_SIZE && state.hasMore && state.batchFetches < cap) { fetchPage(); return; }
          state.loading = false;
          loadingEl.hidden = true;
          moreBtn.hidden = !state.hasMore;
          if (!stripDone) { buildStrip(); stripDone = true; } // strip = this batch's photos (per scope)
          updateEmptyState();
          if (pendingNav) applyPendingNav(); // a Next at the boundary was deferred → apply now photos landed
        })
        .catch(function () {
          state.loading = false; loadingEl.hidden = true;
          pendingNav = false; // failed fetch → don't leave a deferred gesture stuck
          if (grid.children.length === 0 || grid.querySelector('.npr-sk')) {
            grid.innerHTML = ''; emptyEl.hidden = false;
            var em = root.querySelector('#nprEmptyMsg'); if (em) em.textContent = 'Could not load reviews. Please refresh.';
            var wb = root.querySelector('#nprWrite'); if (wb) wb.hidden = true;
          }
        });
    }

    /* ----- sort ----- (size/frame filters intentionally omitted on the product page) */
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; load(true); });
    moreBtn.addEventListener('click', function () { load(false); });

    /* ----- clickable rating bars → toggle filter by that star (Amazon-style) ----- */
    root.querySelector('#nprBars').addEventListener('click', function (e) {
      var bar = e.target.closest('.npr-bar'); if (!bar) return;
      var r = parseInt(bar.dataset.rating, 10);
      state.rating = (state.rating === r) ? null : r;
      applyBarActive();
      load(true);
    });

    /* ----- photo wall → open the gallery lightbox + chevron scrolling ----- */
    photoStrip.addEventListener('click', function (e) {
      var t = e.target.closest('.npr-strip-thumb'); if (!t) return;
      openLb(parseInt(t.dataset.flat, 10) || 0);
    });
    function stripScroll(dir) { photoStrip.scrollBy({ left: dir * photoStrip.clientWidth * 0.85, behavior: 'smooth' }); }
    if (stripPrev) stripPrev.addEventListener('click', function () { stripScroll(-1); });
    if (stripNext) stripNext.addEventListener('click', function () { stripScroll(1); });
    photoStrip.addEventListener('scroll', function () { updateStripNav(); }, { passive: true });

    /* ----- "Read more" (review text) + "View Nordic Park reply" toggles (cards + lightbox) ----- */
    root.addEventListener('click', function (e) {
      var rt = e.target.closest('.npr-reply-toggle');
      if (rt) {
        var open = rt.nextElementSibling.classList.toggle('is-open');
        rt.setAttribute('aria-expanded', open ? 'true' : 'false');
        rt.querySelector('.npr-rt-txt').textContent = open ? 'Hide Nordic Park reply' : 'View Nordic Park reply';
        return;
      }
      var b = e.target.closest('.npr-more-btn'); if (!b) return;
      var text = b.previousElementSibling; if (!text) return;
      var clamped = text.classList.toggle('npr-clamp2');
      b.textContent = clamped ? b.dataset.more : b.dataset.less;
    });

    /* ----- re-square photos on resize ----- */
    var rsTimer;
    window.addEventListener('resize', function () { clearTimeout(rsTimer); rsTimer = setTimeout(function () { sizeSquares(); trimMoreBtns(); }, 150); });

    /* ----- lightbox: a gallery over ALL loaded customer photos, with zoom + pan + swipe ----- */
    var lb = root.querySelector('#nprLb'), lbImg = root.querySelector('#nprLbImg');
    var lbInfo = root.querySelector('#nprLbInfo'), lbCount = root.querySelector('#nprLbCount');
    var lbPrev = root.querySelector('#nprLbPrev'), lbNext = root.querySelector('#nprLbNext');
    var lbMedia = root.querySelector('.npr-lb-media');
    var lbPanel = root.querySelector('.npr-lb-panel');
    var lbPos = 0;
    var pendingNav = false; // a forward gesture made at the loading boundary, applied when photos arrive
    // are more PHOTOS still coming? ("photos first" loads all photos in phase 1, then photo-less reviews
    // in phase 2 — so once phase 1 is done there are no more photos to fetch for the gallery)
    function morePhotosComing() {
      if (state.scope === 'product') return groupShown < groupView.length; // group = client-side slices
      return state.sort === 'photos' ? (state.phase === 1 && state.hasMore) : state.hasMore;
    }

    /* zoom/pan state for the current photo */
    var z = { s: 1, x: 0, y: 0 };
    function applyZoom() {
      lbImg.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
      lbImg.style.cursor = z.s > 1 ? 'grab' : 'zoom-in';
    }
    function clampPan() {
      var mx = Math.max(0, (z.s - 1) * lbImg.offsetWidth / 2);
      var my = Math.max(0, (z.s - 1) * lbImg.offsetHeight / 2);
      z.x = Math.max(-mx, Math.min(mx, z.x));
      z.y = Math.max(-my, Math.min(my, z.y));
    }
    function setScale(ns) {
      z.s = Math.max(1, Math.min(4, ns));
      if (z.s === 1) { z.x = 0; z.y = 0; }
      clampPan(); applyZoom();
    }
    function resetZoom() { z.s = 1; z.x = 0; z.y = 0; lbImg.style.transition = ''; applyZoom(); }

    function showLbImg() {
      var p = allPhotos[lbPos]; if (!p) return;
      lbImg.src = p.url;
      var r = reviewStore[p.revIdx];
      lbInfo.innerHTML = reviewBodyInner(r) + prodHTML(r);
      // lightbox shows full text/reply — drop the clamps + toggles
      lbInfo.querySelectorAll('.npr-clamp2').forEach(function (el) { el.classList.remove('npr-clamp2'); });
      lbInfo.querySelectorAll('.npr-more-btn').forEach(function (b) { b.style.display = 'none'; });
      lbInfo.querySelectorAll('.npr-reply-collapse').forEach(function (c) { c.classList.add('is-open'); });
      lbInfo.querySelectorAll('.npr-reply-toggle').forEach(function (b) { b.style.display = 'none'; });
      var multi = allPhotos.length > 1 || state.hasMore;
      lbPrev.hidden = !multi; lbNext.hidden = !multi; lbCount.hidden = !multi;
      // show the TRUE total (e.g. "12 / 1,000+") for trust, falling back to the loaded count
      if (multi) lbCount.textContent = (lbPos + 1) + ' / ' + photoTotalLabel();
      resetZoom();
      lbPanel.scrollTop = 0;
      // keep loading more photos as the user nears the end so they can browse (nearly) all of them
      if (morePhotosComing() && !state.loading && (allPhotos.length - lbPos) <= 8) load(false);
    }
    function openLb(flatIdx) {
      if (!allPhotos.length) return;
      lbPos = Math.max(0, Math.min(allPhotos.length - 1, flatIdx || 0));
      showLbImg();
      lb.hidden = false; document.body.style.overflow = 'hidden';
    }
    function closeLb() { lb.hidden = true; document.body.style.overflow = ''; resetZoom(); }
    function nav(d) {
      if (!allPhotos.length) return;
      var next = lbPos + d;
      if (next < 0) next = allPhotos.length - 1;            // wrap to the end
      else if (next >= allPhotos.length) {
        if (morePhotosComing()) {
          pendingNav = true; load(false);                   // defer; advance when photos land
          applyPendingNav();                                // group scope loads synchronously → apply now
          return;
        }
        next = 0;                                            // true end → wrap to the start
      }
      lbPos = next; showLbImg();
    }
    // Apply a deferred forward gesture once newly-loaded photos are present (no-op if none arrived yet).
    function applyPendingNav() {
      if (!pendingNav || lb.hidden) return;
      if (lbPos + 1 < allPhotos.length) { pendingNav = false; lbPos += 1; showLbImg(); }
      else if (!state.loading && !morePhotosComing()) { pendingNav = false; } // nothing more coming → drop it
    }

    grid.addEventListener('click', function (e) {
      var m = e.target.closest('.npr-card-media'); if (!m) return;
      e.preventDefault();
      openLb(parseInt(m.dataset.flat, 10) || 0);
    });
    root.querySelector('#nprLbClose').addEventListener('click', closeLb);
    lbPrev.addEventListener('click', function (e) { e.stopPropagation(); nav(-1); });
    lbNext.addEventListener('click', function (e) { e.stopPropagation(); nav(1); });
    root.querySelector('#nprLbBackdrop').addEventListener('click', closeLb);
    root.querySelector('#nprLbZoomIn').addEventListener('click', function (e) { e.stopPropagation(); setScale(z.s + 0.6); });
    root.querySelector('#nprLbZoomOut').addEventListener('click', function (e) { e.stopPropagation(); setScale(z.s - 0.6); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') closeLb();
      else if (e.key === 'ArrowLeft') nav(-1);
      else if (e.key === 'ArrowRight') nav(1);
      else if (e.key === '+' || e.key === '=') setScale(z.s + 0.4);
      else if (e.key === '-') setScale(z.s - 0.4);
    });

    /* desktop: wheel to zoom, double-click to toggle, drag to pan */
    lbMedia.addEventListener('wheel', function (e) {
      if (lb.hidden) return;
      e.preventDefault();
      setScale(z.s * (e.deltaY < 0 ? 1.18 : 0.85));
    }, { passive: false });
    lbImg.addEventListener('dblclick', function (e) { e.preventDefault(); setScale(z.s > 1 ? 1 : 2.5); });
    var mDrag = false, mSX, mSY, mOX, mOY;
    lbImg.addEventListener('mousedown', function (e) {
      if (z.s <= 1) return;
      e.preventDefault(); mDrag = true; mSX = e.clientX; mSY = e.clientY; mOX = z.x; mOY = z.y;
      lbImg.style.transition = 'none'; lbImg.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', function (e) {
      if (!mDrag) return;
      z.x = mOX + (e.clientX - mSX); z.y = mOY + (e.clientY - mSY); clampPan(); applyZoom();
    });
    window.addEventListener('mouseup', function () { if (mDrag) { mDrag = false; lbImg.style.transition = ''; lbImg.style.cursor = z.s > 1 ? 'grab' : 'zoom-in'; } });

    /* touch: pinch-zoom, 1-finger pan when zoomed, horizontal swipe to change photo,
       vertical drag scrolls the panel, double-tap to toggle zoom */
    var tp = {};
    function tDist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
    lbMedia.addEventListener('touchstart', function (e) {
      lbImg.style.transition = 'none';
      if (e.touches.length === 2) {
        tp.pinch = true; tp.d0 = tDist(e.touches[0], e.touches[1]); tp.s0 = z.s; e.preventDefault();
      } else if (e.touches.length === 1) {
        tp.pinch = false; tp.sx = e.touches[0].clientX; tp.sy = e.touches[0].clientY;
        tp.ox = z.x; tp.oy = z.y; tp.dir = null; tp.dx = 0; tp.scroll0 = lbPanel.scrollTop;
        var now = Date.now();
        if (now - (tp.lastTap || 0) < 300) { e.preventDefault(); setScale(z.s > 1 ? 1 : 2.5); tp.lastTap = 0; }
        else { tp.lastTap = now; }
      }
    }, { passive: false });
    lbMedia.addEventListener('touchmove', function (e) {
      if (tp.pinch && e.touches.length === 2) {
        e.preventDefault(); setScale(tp.s0 * (tDist(e.touches[0], e.touches[1]) / tp.d0)); return;
      }
      if (e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - tp.sx, dy = e.touches[0].clientY - tp.sy;
      if (z.s > 1) { e.preventDefault(); z.x = tp.ox + dx; z.y = tp.oy + dy; clampPan(); applyZoom(); return; }
      if (!tp.dir && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) tp.dir = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
      if (tp.dir === 'h') { e.preventDefault(); tp.dx = dx; }
      else if (tp.dir === 'v') { e.preventDefault(); lbPanel.scrollTop = tp.scroll0 - dy; }
    }, { passive: false });
    lbMedia.addEventListener('touchend', function () {
      lbImg.style.transition = '';
      if (tp.pinch) { tp.pinch = false; if (z.s < 1.05) resetZoom(); return; }
      if (z.s <= 1 && tp.dir === 'h' && Math.abs(tp.dx) > 45) nav(tp.dx < 0 ? 1 : -1);
      tp.dir = null; tp.dx = 0;
    });

    /* ----- scope (this artwork / all Nordic Park) ----- */
    function setScope(scope) {
      if (!GROUP_IDS.length) scope = 'all';
      state.scope = scope;
      state.size = null; state.frame = null; state.rating = null;
      scopeEl.querySelectorAll('.npr-scope-btn').forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.scope === scope ? 'true' : 'false'); });
      scopeNote.hidden = false;
      scopeNote.textContent = scope === 'all' ? 'Showing all Nordic Park reviews'
        : (IS_GROUP ? 'Showing reviews for this artwork — all sizes & shapes' : 'Showing reviews for this artwork');
      if (scope === 'all') buildSummary(); // product/group summary is rendered by loadGroup
      load(true);
    }
    if (scopeEl) scopeEl.addEventListener('click', function (e) {
      var b = e.target.closest('.npr-scope-btn'); if (!b || b.dataset.scope === state.scope) return;
      setScope(b.dataset.scope);
    });
    // 2026-09-29 (Ollie): the review row at the top of the PDP has two facts — "this artwork" and "Nordic Park" — each a
    // link to this widget carrying data-npr-scope="product" | "all". Clicking one lands here AND shows that scope: before
    // the widget has loaded the request is remembered and used instead of the count-based default; after, it just switches.
    var wantScope = null;
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-npr-scope]'); if (!a) return;
      wantScope = a.getAttribute('data-npr-scope') === 'product' ? 'product' : 'all';
      if (!started) start();
      else if (countsReady && wantScope !== state.scope) setScope(wantScope);
    }, true);
    var countsReady = false;
    function wireWrite(el) {
      if (!el) return;
      el.addEventListener('click', function () {
        try {
          if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') window.LOOX.showReviewForm(PRODUCT_ID);
          else if (typeof window.looxWrite === 'function') window.looxWrite(PRODUCT_ID);
        } catch (e) {}
      });
    }
    wireWrite(root.querySelector('#nprWrite'));
    wireWrite(root.querySelector('#nprWriteTop'));

    /* ----- go: defer the data load until the widget scrolls into view (PDP perf) ----- */
    function init() {
      // "This artwork" count = sum across the group's shape-variant products
      var pProd = GROUP_IDS.length
        ? Promise.all(GROUP_IDS.map(function (id) {
            return fetch(BASE + '?product_id=' + id + '&limit=1').then(function (r) { return r.json(); }).then(function (j) { return (j.pagination && j.pagination.total) || 0; }).catch(function () { return 0; });
          })).then(function (arr) { return arr.reduce(function (a, b) { return a + b; }, 0); })
        : Promise.resolve(0);
      var pStore = fetch(BASE + '?limit=1').then(function (r) { return r.json(); }).then(function (j) { return (j.pagination && j.pagination.total) || 0; }).catch(function () { return 0; });
      Promise.all([pProd, pStore]).then(function (c) {
        productCount = c[0]; storeCount = c[1];
        root.querySelector('#nprScopeProdN').textContent = '(' + productCount.toLocaleString() + ')';
        root.querySelector('#nprScopeAllN').textContent = '(' + roundAll(storeCount) + ')';
        if (scopeEl) scopeEl.hidden = !(GROUP_IDS.length && productCount > 0);   // 0 reviews: no "This artwork (0)" toggle, the widget just shows All (Ollie 2026-10-04)
        countsReady = true;
        setScope(wantScope || (GROUP_IDS.length && productCount >= THRESHOLD ? 'product' : 'all'));
      });
    }
    var started = false;
    function start() { if (started) return; started = true; init(); }
    showSkeletons();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); start(); }
      }, { rootMargin: '600px' });
      io.observe(root);
      // fallback: start on first scroll once the widget is near the viewport (covers IO edge cases)
      var onScroll = function () {
        if (root.getBoundingClientRect().top < window.innerHeight + 600) { window.removeEventListener('scroll', onScroll); start(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      // last-resort: if it's already near the top of the page, start shortly after load
      if (root.getBoundingClientRect().top < window.innerHeight + 600) setTimeout(start, 200);
    } else { start(); }
    // 2026-10-23 (Ollie: reviews took ~5 s to appear after scrolling): also start once the page has finished loading,
    // so the two rounds of Loox calls are done before the shopper scrolls down. Photos stay loading="lazy", so this only
    // fetches review text (~8 small JSON calls) and never competes with the main image.
    var early = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(start, { timeout: 2000 }); };
    if (document.readyState === 'complete') setTimeout(early, 500);
    else window.addEventListener('load', function () { setTimeout(early, 500); }, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
